"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_MedicationDispense = void 0;
var t = __importStar(require("io-ts"));
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Meta_1 = require("./RTTI_Meta");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Narrative_1 = require("./RTTI_Narrative");
var RTTI_ResourceList_1 = require("../Union/RTTI_ResourceList");
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_MedicationDispense_Performer_1 = require("./RTTI_MedicationDispense_Performer");
var RTTI_Quantity_1 = require("./RTTI_Quantity");
var RTTI_dateTime_1 = require("../Scalar/RTTI_dateTime");
var RTTI_Annotation_1 = require("./RTTI_Annotation");
var RTTI_Dosage_1 = require("./RTTI_Dosage");
var RTTI_MedicationDispense_Substitution_1 = require("./RTTI_MedicationDispense_Substitution");
exports.RTTI_MedicationDispense = t.recursion('IMedicationDispense', function () {
    return t.intersection([
        t.type({
            resourceType: t.literal('MedicationDispense')
        }),
        t.partial({
            id: RTTI_id_1.RTTI_id,
            meta: RTTI_Meta_1.RTTI_Meta,
            implicitRules: RTTI_uri_1.RTTI_uri,
            _implicitRules: RTTI_Element_1.RTTI_Element,
            language: RTTI_code_1.RTTI_code,
            _language: RTTI_Element_1.RTTI_Element,
            text: RTTI_Narrative_1.RTTI_Narrative,
            contained: t.array(RTTI_ResourceList_1.RTTI_ResourceList),
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            identifier: t.array(RTTI_Identifier_1.RTTI_Identifier),
            partOf: t.array(RTTI_Reference_1.RTTI_Reference),
            status: RTTI_code_1.RTTI_code,
            _status: RTTI_Element_1.RTTI_Element,
            statusReasonCodeableConcept: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            statusReasonReference: RTTI_Reference_1.RTTI_Reference,
            category: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            medicationCodeableConcept: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            medicationReference: RTTI_Reference_1.RTTI_Reference,
            subject: RTTI_Reference_1.RTTI_Reference,
            context: RTTI_Reference_1.RTTI_Reference,
            supportingInformation: t.array(RTTI_Reference_1.RTTI_Reference),
            performer: t.array(RTTI_MedicationDispense_Performer_1.RTTI_MedicationDispense_Performer),
            location: RTTI_Reference_1.RTTI_Reference,
            authorizingPrescription: t.array(RTTI_Reference_1.RTTI_Reference),
            type: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            quantity: RTTI_Quantity_1.RTTI_Quantity,
            daysSupply: RTTI_Quantity_1.RTTI_Quantity,
            whenPrepared: RTTI_dateTime_1.RTTI_dateTime,
            _whenPrepared: RTTI_Element_1.RTTI_Element,
            whenHandedOver: RTTI_dateTime_1.RTTI_dateTime,
            _whenHandedOver: RTTI_Element_1.RTTI_Element,
            destination: RTTI_Reference_1.RTTI_Reference,
            receiver: t.array(RTTI_Reference_1.RTTI_Reference),
            note: t.array(RTTI_Annotation_1.RTTI_Annotation),
            dosageInstruction: t.array(RTTI_Dosage_1.RTTI_Dosage),
            substitution: RTTI_MedicationDispense_Substitution_1.RTTI_MedicationDispense_Substitution,
            detectedIssue: t.array(RTTI_Reference_1.RTTI_Reference),
            eventHistory: t.array(RTTI_Reference_1.RTTI_Reference)
        })
    ]);
});
//# sourceMappingURL=RTTI_MedicationDispense.js.map